//
//
//
//
//
//
//
//
//

import { faBolt } from '@fortawesome/pro-solid-svg-icons';

export default {
  name: 'SubscribeHero2026Heading',
  data() {
    return {
      faBolt,
    };
  },
};
